export default "__VITE_ASSET__BJgkxFcm__"